<template>
	<div v-if="blok" v-editable="blok" class="mx-auto md:mx-0 grid gap-y-8">
		<div
			:class="blok.class"
			:data-shop-id="blok.shop_id"
			:data-market="blok.market"
			:data-layout="blok.layout"
		/>
	</div>
</template>

<script setup lang="ts">
import type { ShopRatingWidget } from "~/types/storyblok/storyblok";

interface Props {
	blok: ShopRatingWidget;
}

const { blok } = defineProps<Props>();

useExternalScript("https://cdn.pji.nu/b2b/widgets/shop-rating/index.js");
</script>
